import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { MetricCard } from './metric-card'

const BloqueFinanciero = ({ data }) => {
    const cuotasVencidas = data?.cuotasVencidasSinLegalizar
    return (
        <Row className='g-2'>
            <Col xs={12} md={6}><MetricCard label='Monto total convenido' value={data?.montoTotalConvenido} format='moneda' colorVariant='neutro' /></Col>
            <Col xs={12} md={6}><MetricCard label='Tasa de cierre con recobro' value={data?.tasaCierreConRecobro} format='porcentaje' colorVariant='verde' /></Col>
            <Col xs={12} md={4}><MetricCard label='Promedio monto convenido' value={data?.promedioMontoConvenido} format='moneda' colorVariant='teal' grande={false} /></Col>
            <Col xs={12} md={4}><MetricCard label='Convenios en cuotas activos' value={data?.conveniosEnCuotasActivos} colorVariant='azul' nota='(estado actual)' grande={false} /></Col>
            <Col xs={12} md={4}>
                <MetricCard
                    label='Cuotas vencidas sin legalizar'
                    value={cuotasVencidas}
                    colorVariant={Number(cuotasVencidas) > 0 ? 'rojo' : 'verde'}
                    nota='(estado actual)'
                    grande={false}
                />
            </Col>
        </Row>
    )
}
export default BloqueFinanciero
